import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "button", "defaultLabel", "copiedLabel"]

  async copy() {
    const value = this.inputTarget.value
    try {
      await navigator.clipboard.writeText(value)
    } catch (_) {
      this.inputTarget.select()
      document.execCommand("copy")
    }
    this._flash()
  }

  _flash() {
    this.defaultLabelTarget.hidden = true
    this.copiedLabelTarget.hidden  = false
    this.buttonTarget.classList.add("is-copied")
    clearTimeout(this._t)
    this._t = setTimeout(() => {
      this.defaultLabelTarget.hidden = false
      this.copiedLabelTarget.hidden  = true
      this.buttonTarget.classList.remove("is-copied")
    }, 1600)
  }
}
